<template>
  <div :class="isPC ? 'content-area' : 'm-content-area'" :style="popInKr ? {backgroundColor: 'transparent'} : {}">
    <p class="page-title">{{ currentLang === 'en' ? '' : ''}}</p>
    <div class="layout">
      <h3 :style="popInKr ? {color: '#fff'} : {}">{{ item.detail_title }}</h3>
      <video class="video-js vjs-big-play-centered" src='https://sslfile.shedu.net.cn/secsa_ai/yunketang/2022keji_mengxiang_chibang.mp4' type='media_type' withCredentials='false' controls preload="auto" v-if="item.id == 'live006'"></video>
      <div class="content" :style="popInKr ? {color: '#fff'} : {}" v-html="item.detail_content"></div>
      <div class="cart-button activity-button">
        <template v-if="item.id !== 'live005' && item.id !== 'live006' ">
          <template v-if="isPC">
            <a :href="item.detail_url" class="btn" target="_blank">{{ item.detail_button }}</a>
          </template>
          <template v-if="!isPC">
            <a :href="item.detail_url_m || item.detail_url" class="btn" target="_blank">{{ item.detail_button }}</a>
          </template>
        </template>
        <template v-if="item.id === 'live005'">
          <a href="javascript:;" @click="goRank()" class="btn">{{ item.detail_button }}</a>
        </template>
        <template v-if="popInKr && !notshowback">
          <a href="javascript:;" @click="goBack()" class="btn" style="margin-left: 20px;">{{ currentLang === 'en' ? 'Back' : '返回'}}</a>
        </template>
      </div>
    </div>
    <Rank :popInKr="popInKr" v-if="showRank" />
  </div>
</template>

<script>
import Rank from '@/common/Rank'
export default {
  name: 'GameDetail',
  components: { Rank },
  props: ['popInKr', 'detail', 'notshowback'],
  data() {
    return {
      showRank: false,
      item: {
        detail_title: '',
        detail_content: '',
        detail_button: ''
      },
      gameList: [
        {
          id: 'live001',
          title: '走进AI',
          imgUrl: require('../../assets/web/game_1.png'),
          detail_button: '报名答题',
          detail_title: '走近AI——AI知识学堂',
          detail_content: '<div>每天一道人工智能相关的知识问答，带你走近AI世界！可以在答题页面查看提示，了解相关内容。20天时间，点亮所有拼图，等你来玩哦！</div><div>【挑战1-3星，适合小学三年级至高中学生。每天一题】</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/走近AI——AI知识学堂.png"></div>',
          detail_url: 'http://ai.secsa.cn'
        },
        {
          id: 'live002',
          title: '探秘AI',
          imgUrl: require('../../assets/web/game_2.png'),
          detail_button: '开始体验',
          detail_title: '探秘AI——腾讯AI体验馆',
          detail_content: '<div>腾讯AI体验馆与AI Lab、腾讯优图、微信智聆等腾讯AI实验室进行合作，将前沿的AI技术用最轻量级的体验方式、最易于理解的交互实验展示出来。实验涉及图像、语音、自然语言、机器学习等算法，为k12学生初识人工智能输送经典案例。</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/探秘AI——腾讯AI体验馆.png"></div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/探秘AI——腾讯AI体验馆2.png"></div>',
          detail_url: 'https://aiep.qcloud.com/#/aiExperience?iSchoolId=10372&iCloudToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJybHMiOiJzdHVkZW50IiwiYWlkIjoiMTAzNzIiLCJzaWQiOiIxMDAwMSIsInVpbiI6IjhkYVU3IiwiZXhwIjoxNTk3OTM5MjU0LCJpYXQiOjE1OTU0NzY0NTR9.jFMZEt1Q7EDT6AKJKIVjo3KnUSaSx_7npg4ZHFvai0U'
        },
        {
          id: 'live003',
          title: 'AI技术大挑战',
          imgUrl: require('../../assets/web/game_3.png'),
          detail_button: '报名参加',
          detail_title: '挑战AI—“挑战AI”作品征集',
          detail_content: '<div>参赛选手可以寻找我们现实生活中的人工智能产品，也可以联想未来人工智能的高科技产品，选择八个主题中的一项进行创作。展现形式可以借助文字表述、画图描述、编程设计、机器人作品、3D作品等元素中的一种或多种来表达自己的想法、展现自己的成果。 作品提交形式为微视频、绘画、研究报告、未来畅想等多种形式。</div><div>微视频文件不超过200M，视频拍摄设备不限，以不低于1280*720分辨率、横画面进行拍摄并最终以MP4格式进行提交。绘画作品上传为JPG格式，文件不超过10M。研究报告、未来畅想原则上不限制形式，提交文件可以是PPT、WORD或者JPG文件，文件不超过10M。</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/挑战AI—“挑战AI”2.png"></div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/挑战AI—“挑战AI”.png"></div>',
          detail_url: 'http://www.aiaction-games.com/signup'
        },
        {
          id: 'live004',
          title: '亲子游戏设计秀',
          imgUrl: require('../../assets/web/game_4.png'),
          detail_button: '报名参加',
          detail_title: '我爱我家-亲子游戏设计秀',
          detail_content: '<div>以“我爱我家”为主题，亲手创作一个独有的拼图游戏，送给爸爸妈妈或者家人，表达你对他们满满的爱，在拼图的过程中与他们一起回忆生活中的美好瞬间。制作时，挑选一张在日常生活中与爸爸妈妈或家人的合照，上传到Edbox平台，根据提示，完成创作，再分享给你的小伙伴们。这看似简单，却能够讲述你与父母家人之间的动人故事。</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/我爱我家-亲子游戏设计秀.png"></div>',
          detail_url: 'https://edbox.101.com/news/07282020/232249789.shtml'
        },
        {
          id: 'live005',
          detail_button: '排行榜',
          detail_title: '火箭加速',
          detail_content: '<div>每个展位有一个火箭，如果喜欢某个展位，可以点赞为其加速。</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/火箭加速.png"></div>',
          detail_url: ''
        },
        {
          id: 'live006',
          detail_button: '报名参加',
          detail_title: '让科技插上梦想的翅膀',
          detail_content: '<div>一、活动简介<br/>1.参加活动的学生用纸张制作一个“飞行器”。<br/>2.拍摄一段30秒以内的视频，在视频中将展示飞行器可以飞行，并从画面左侧进入镜头，继而从画面右侧离开。</div><div style="margin-top:20px;">二、制作规则<br/>1、纸张限制<br/>类型：打印纸、牛皮纸、卡纸、报纸等中的任一种。<br/>尺寸：不小于A4（210mm×297mm）。<br/>数量：1-2张<br/>2、制作方法<br/>模型可以通过折叠、撕裂、剪裁、切割制作而成，在制作过程中不能粘贴、装订或填装其他物品。<br/>3、“飞行器”造型<br/>制成的“飞行器”模型必须是典型的飞机造型，至少有一对机翼。可以包含球状或杆状部件但不能将“飞行器”做成球状或杆状。<br/>4、飞行能力<br/>制成的“飞行器”模型必须具备基本飞行能力，可在空中停留时间大于3秒。</div><div style="margin-top:20px;">三、视频提交规则<br/>1、拍摄一段30秒以内的视频，在视频中将展示“飞行器”可以飞行。<br/>2、“飞行器”飞行流程为：从画面左侧进入，从画面右侧离开。<br/>3、在提交的视频片段中，可以简短介绍展示“飞行器”的制作亮点、制作过程。并用本国和本地区的语言，用一句话说出你对科技的热爱或梦想。<br/>4、视频必须水平拍摄（切勿竖屏拍摄），所有内容控制在30秒以内，可以剪辑，但无需配背景音乐。<br/>5、视频提交至：mrkjzx2021@163.com，邮件名请标注学校名+姓名+联系方式。</div>',
          detail_url: 'http://qingbohui.secsa.cn/QBHGame/index',
          detail_url_m: 'http://qingbohui.secsa.cn/QBHGame/Mindex'
        }
      ],
      gameListEn: [
        {
          id: 'live001',
          title: 'Knowing about AI',
          imgUrl: require('../../assets/web/game_1.png'),
          detail_button: 'Sign Up',
          detail_title: 'Knowing about AI——AI Classroom',
          detail_content: '<div>A question on artificial intelligence a day to lead you to the world of AI!You may read the hints on the page of the questions to know more about relevant information. Light up all the puzzles in 20 days. We are looking forward to your participation!</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/走近AI——AI知识学堂.png"></div>',
          detail_url: 'http://ai.secsa.cn'
        },
        {
          id: 'live002',
          title: 'Exploring AI',
          imgUrl: require('../../assets/web/game_2.png'),
          detail_button: 'Experience',
          detail_title: 'Exploring AI——Tencent AI Experience Hall',
          detail_content: '<div>Tencent AI Experience Hall cooperates with Tencent AI Labs such as AI Lab, Tencent Youtu, WeChat Zhiling, etc., and displays cutting-edge AI technology with the lightest experience and the easiest interactive experiment to understand. The experiment involves algorithms such as image, natural language progression and machine learning, which provides classic cases for k12 students to learn artificial intelligence.</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/探秘AI——腾讯AI体验馆.png"></div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/探秘AI——腾讯AI体验馆2.png"></div>',
          detail_url: 'https://aiep.qcloud.com/#/aiExperience?iSchoolId=10372&iCloudToken=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJybHMiOiJzdHVkZW50IiwiYWlkIjoiMTAzNzIiLCJzaWQiOiIxMDAwMSIsInVpbiI6IjhkYVU3IiwiZXhwIjoxNTk3OTM5MjU0LCJpYXQiOjE1OTU0NzY0NTR9.jFMZEt1Q7EDT6AKJKIVjo3KnUSaSx_7npg4ZHFvai0U'
        },
        {
          id: 'live003',
          title: 'Challenging AI',
          imgUrl: require('../../assets/web/game_3.png'),
          detail_button: 'Sign Up',
          detail_title: 'Challenging AI——Outstanding Work Collection for "the challenge of AI"',
          detail_content: '<div>Introduction: competitors can look for AI products in our real life, or associate them with high-tech AI products in the future, and choose one of the eight themes for creation.</div><div>One or more of the elements such as language expression, drawing description, programming design, robot works and 3D works can be used to express their ideas and show their achievements. Works are submitted in the form of micro videos, paintings, research reports, future imagination and other forms.</div><div>A single video file is no more than 200m. Video capture equipment is not limited, with resolution no less than 1280 * 720 and horizontal screen, and finally submitted in MP4 format. The painting is uploaded in JPG format and the file does not exceed 10M. In principle, the research report and future imagination do not limit the form. The submitted documents can be PPT, WORD or JPG, and the documents should not exceed 10M.</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/挑战AI—“挑战AI”2.png"></div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/挑战AI—“挑战AI”.png"></div>',
          detail_url: 'http://www.aiaction-games.com/signup'
        },
        {
          id: 'live004',
          title: 'Parent-child Game Design Show',
          imgUrl: require('../../assets/web/game_4.png'),
          detail_button: 'Sign Up',
          detail_title: 'Parent-Child Game Design Show- I love my family',
          detail_content: '<div>Create a unique jigsaw puzzle with the theme of "I love my family". Reminisce the beautiful moment of your lives together with your family while playing it. To start with, pick a daily family photo and upload it to Edbox. Follow the prompts to complete the creation and share it. Come and tell the moving story between you and your family!</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/我爱我家-亲子游戏设计秀.png"></div>',
          detail_url: 'https://edbox.101.com/news/07282020/232249789.shtml'
        },
        {
          id: 'live005',
          detail_button: 'Ranking List',
          detail_title: 'Rocket Speed Acceleration Rules',
          detail_content: '<div>At each exhibition stand there is a rocket, and you may help it speed up with your “like” when you like that stand.</div><div style="text-align: center;"><img style="margin: 20px 0;width: 70%;" src="https://cdn.shsunshine.org/qbh/image/火箭加速.png"></div>',
          detail_url: ''
        },
        {
          id: 'live006',
          detail_button: 'Sign Up',
          detail_title: 'Let Technology Possesses Wings of Dreams',
          detail_content: '<div>A.	Introduction<br/>1.	Students use paper of required type to make an Aircraft.<br/>2.	Shoot a video of no longer than 30 seconds. Video needs to show that Aircraft can fly by entering from the left side of shooting picture and then leave from its right side.</div><div style="margin-top:20px;">B.	Requirements<br/>1.	Paper:<br/>a)	May choose one of following paper types:<br/>● Printing paper<br/>● Kraft paper<br/>● Cardboard<br/>● Newspaper<br/>b)	Size: at least A4 (210mm × 297mm).<br/>c)	Quantity: up to 2 pieces<br/>2.	Production:<br/>Aircraft can be produced by folding, tearing, trimming, cutting, and cannot be pasted, stapled, or filled with other items during production process.<br/>3.	Aircraft Appearance: <br/>a)	Aircraft must be of a typical aircraft shape, with at least one pair of wings;<br/>b)	Spherical or rod-shaped parts may be included;<br/>c)	Aircraft cannot be made into a spherical or rod-shaped form.<br/>4.	Flight Ability<br/>Aircraft must have basic flight ability and may stay in the air for more than 3 seconds.</div><div style="margin-top:20px;">C.	Submission<br/>1.	Shoot a video of no longer than 30 seconds, which needs to show that Aircraft may fly by showing the flight process of Aircraft.<br/>2.	Flight process of Aircraft is: <br/>i.	Entering from left side of shooting picture<br/>ii.	Then leaving from right side of shooting picture.<br/>3.	In the submitted video, you can first introduce the highlights and process of production of Aircraft. And then in the language of your country and region, describe your love or dream about technology in one sentence.<br/>4.	The video must be shot in landscape (DO NOT shoot in portrait). Contents could be edited, but the completed video should not be longer than 30 seconds. Background music is not required.<br/>5.	The video submitted to: mrkjzx2021@163.com , please mark your school name +  full name +  contact information.</div>',
          detail_url: 'http://qingbohui.secsa.cn/QBHGame/Eindex',
          detail_url_m: 'http://qingbohui.secsa.cn/QBHGame/EMindex'
        }
      ]
    }
  },
  mounted() {
    let id = ''

    if (this.popInKr) {
      id = this.detail
    } else {
      let params = this.$route.params || {}
      id = params.id || ''
    }

    console.log('mounted: ' + id)
    if (id) {
      this.initData(id)
    }
  },
  methods: {
    initData(id) {
      console.log('initData: ' + id)
      if (this.currentLang === 'en') {
        this.item = this.gameListEn.filter((i) => {
          return i.id === id
        })[0]
      } else {
        this.item = this.gameList.filter((i) => {
          return i.id === id
        })[0]
      }
    },
    goRank() {
      this.showRank = true
    },
    goBack() {
      this.$parent.detail = ''
    }
  }
}
</script>

<style scoped>
.content-area {
  width: 100%;
  min-height: 400px;
  background-color: #f5f5f6;
  text-align: center;
  padding-bottom: 5rem;
}
.content-area p {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
}
.page-title {
  text-align: center;
  color: #343434;
  padding-top: 3rem;
  padding-bottom: 3rem;
  font-size: 2.5rem;
}
.content {
  /*width: 80rem;*/
  /*margin: 2rem auto;*/
  /*text-align: left;*/
}
.m-content-area .page-title {
  font-size: 16px;
}
.m-content-area {
  width: 100%;
  height: 100%;
  background-color: #f5f5f6;
}
.m-content-area p {
  padding-top: 20px;
  text-align: center;
}
.layout {
  width: 80rem;
  margin: 0 auto;
  text-align: left;
}
.m-content-area .layout {
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 40px;
}
.m-content-area .layout .content {
  padding: 0 20px;
}
h3 {
  margin-top: 6rem;
  margin-bottom: 3rem;
  font-size: 3rem;
  text-align: center;
}
.m-content-area h3 {
  font-size: 18px;
  font-weight: bold;
}

.cart-button {
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
  text-align: center;
}
.cart-button a {
  cursor: pointer;
  padding: 0.8rem 4rem;
  border-radius: 2rem;
  font-size: 1.8rem;
  display: inline-block;
}
.m-content-area .cart-button a {
  font-size: 14px;
  border-radius: 14px;
  color: #ffffff;
  background-color: #ec6000;
}
.m-content-area .activity-button a {
  color: #ffffff;
  background-color: #ec6000;
  border: 1px solid #ec6000;
}
.activity-button a {
  color: #ec6000;
  border: 1px solid #ec6000;
}
.activity-button a:hover {
  background-color: #ec6000;
  color: #ffffff;
}
.video-js {
  margin: 0 auto 3rem;
  width: 80%;
  height: auto;
  padding: 1px;
}
</style>
